import {
    Component, Input, OnInit, ViewEncapsulation
} from '@angular/core';
import { Store } from '@ngxs/store';
import { ModulesSelectors } from '@serviceos-ng/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'serviceos-web-mobile-screen',
    templateUrl: './mobile-screen.component.html',
    styleUrls: ['./mobile-screen.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MobileScreenComponent implements OnInit {

    public hideMobileScreen = true;
    public mobileBannerConfig: any = null;

    @Input()
    backgroundImageUrl;
    
    constructor(
        private store: Store,
        private cookieService: CookieService
        ) {}

    ngOnInit(): void {
        this.store.select(ModulesSelectors.getComponentFromModule('customer', 'mobile_banner'))
            .subscribe(
                (mobileBanner) => {
                    this.mobileBannerConfig = mobileBanner;
                    if (!this.cookieService.get('mobile_banner_close')) {
                        this.hideMobileScreen = false;
                    }
                }
            );
    }

    public close() {
        this.hideMobileScreen = true;
        this.cookieService.set(
            'mobile_banner_close',
            JSON.stringify(1),
            0.2
        );
    }

    
}
